import { makeStyles } from 'tss-react/mui';
import { GRAY_ALTERNATIVE, PRIMARY_PAYMENT_DARK, PRIMARY_PAYMENT_DEFAULT } from "src/global/theme/colors";

export const styles = makeStyles()(() => {
    return {
        container: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignSelf: "center",
            gap: "24px",
            width: "30%",
            backgroundColor: GRAY_ALTERNATIVE,
        },
        componentContainer: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignSelf: "center",
        },
        button: {
            padding: "16px",
            backgroundColor: PRIMARY_PAYMENT_DARK,

            '&:hover': {
                backgroundColor: PRIMARY_PAYMENT_DEFAULT,
            },
        },
    };
});
